import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApplepayComponent } from './simple-icons-applepay.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApplepayComponent ],
    exports:      [ SimpleIconsApplepayComponent ],
    bootstrap:    []
})
export class SimpleIconsApplepayModule {}
